// These ID correspond with merchant-relevant Zendesk category IDs found at https://merchant-help.zip.co/hc/en-au
export enum HelpCentreCategories {
  BecomeAZipPartner = 13836787731343,
  ManagingYourAccount = 13836773424655,
  TrainingResources = 13836778286991,
  Marketing = 13836808067727,
  Integration = 13836803007631,
  ZipSupport = 13836802546447,
}
